/**
 * "SURVIVE" banner + countdown shown during a boss's desperation finale (see
 * SpawningSystem._updateDesperation). The boss is invulnerable and the player
 * can only survive an escalating barrage for a fixed window — this tells them
 * that, and how long is left. Purely presentational; it reads the remaining
 * time straight off `desperation:tick` so the countdown stays in sync with the
 * (pausable) simulation rather than drifting on its own timer.
 */
export class SurviveOverlay {
  constructor(eventBus, root) {
    this.root = root;
    this.el = null;
    this.countEl = null;
    eventBus.on('boss:desperation-start', () => this._show());
    eventBus.on('desperation:tick', ({ remaining }) => this._update(remaining));
    eventBus.on('boss:died', () => this._hide());
    // The boss is invulnerable during desperation, but the player can still
    // die to the barrage — that ends the run (run:ended) without boss:died
    // ever firing, which used to leave this banner stuck on screen through
    // the run-end overlay and into the next run.
    eventBus.on('run:ended', () => this._hide());
  }

  _show() {
    if (this.el) return;
    const el = document.createElement('div');
    el.className = 'survive-overlay';
    el.innerHTML = `
      <div class="survive-title">SURVIVE</div>
      <div class="survive-count">--</div>
    `;
    this.root.appendChild(el);
    this.el = el;
    this.countEl = el.querySelector('.survive-count');
  }

  _update(remaining) {
    if (this.countEl) this.countEl.textContent = Math.ceil(remaining).toString();
  }

  _hide() {
    this.el?.remove();
    this.el = null;
    this.countEl = null;
  }
}
